import React, {FunctionComponent, useEffect, useRef, useState} from "react";
import Tile from "../Tile/Tile";
import styles from "../TileContainer/TileContainer.module.scss";
import JSONContent from "../TileContainer/content";
import {renderToString} from "react-dom/server";
import supStyles from "./../atoms/Superscript/Superscript.module.scss";
import classNames from "classnames";


const TileContainer: FunctionComponent<{
    contentOrder: any, isStartSmart: boolean, isCardOnOff: boolean, userStylesApplied: boolean; focus: string
}> = ({contentOrder, isStartSmart, isCardOnOff, userStylesApplied, focus}) => {

    const [loaded, setLoaded] = useState(false);
    const [selected, setSelected] = useState(0);

    const dataLang = process.env.REACT_APP_LANG === 'spanish' ? 'es' : 'en';

    let openHeight;

    if (window.innerWidth >= 1080) {
        openHeight = 600;
    } else if (window.innerWidth < 1080 && window.innerWidth >=768) {
        openHeight = 300;
    } else if (window.innerWidth < 768) { // backround image is expanded to 360px height in the CSS.  that's the max we should go.
        if (dataLang === 'es') {
            openHeight = 328;
        } else {
            openHeight = 300;
        }
    }



    let [tileHeightOpen, setTileHeightOpen] = useState(openHeight)
    let [tileHeightClosed, setTileHeightClosed] = useState(window.innerWidth < 1080 ? 210 : 456)
    let [titleHeight, setTitleHeight] = useState(0)

    const tileRef0 = useRef<HTMLDivElement>(null)
    const tileRef1 = useRef<HTMLDivElement>(null)
    const tileRef2 = useRef<HTMLDivElement>(null)
    const tileRef3 = useRef<HTMLDivElement>(null)
    const tileRef4 = useRef<HTMLDivElement>(null)
    let tileRefs: any[] = [
        tileRef0,
        tileRef1,
        tileRef2,
        tileRef3,
        tileRef4,
    ];


    const contentRef0 = useRef<HTMLDivElement>(null)
    const contentRef1 = useRef<HTMLDivElement>(null)
    const contentRef2 = useRef<HTMLDivElement>(null)
    const contentRef3 = useRef<HTMLDivElement>(null)
    const contentRef4 = useRef<HTMLDivElement>(null)
    let contentRefs: any[] = [
        contentRef0,
        contentRef1,
        contentRef2,
        contentRef3,
        contentRef4,
    ];

    const tabCopy = process.env.REACT_APP_LANG !== 'spanish'
        ? [
            {
                heading: <>Stay on top of&nbsp;your subscriptions</>,
                body: {
                    default: <>With Fargo&reg;,<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> your virtual assistant in the Wells Fargo Mobile&reg; app, you can quickly track subscriptions. </>,
                    spending: <>With Fargo&reg;,<a id="body-sup-1" className={supStyles.bodySup} href="" aria-label="footnote 1"><sup>1</sup></a> your virtual assistant in the Wells Fargo Mobile&reg; app, you can quickly track subscriptions. </>,
                    insights: <>With Fargo&reg;,<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> your virtual assistant in the Wells Fargo Mobile&reg; app, you can quickly track subscriptions. </>,
                    savings: <>With Fargo&reg;,<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> your virtual assistant in the Wells Fargo Mobile&reg; app, you can quickly track subscriptions. </>,
                    startsmart: <>With Fargo&reg;,<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> your virtual assistant in the Wells Fargo Mobile&reg; app, you can quickly track subscriptions. </>,
                    subscriptions: <>With Fargo&reg;,<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> your virtual assistant in the Wells Fargo Mobile&reg; app, you can quickly track subscriptions. </>,
                    cardonoff: <>With Fargo&reg;,<a id="body-sup-4" className={supStyles.bodySup} href="" aria-label="footnote 4"><sup>4</sup></a> your virtual assistant in the Wells Fargo Mobile&reg; app, you can quickly track subscriptions. </>,
                },
                class: "bg0",
                alt: "A man wearing headphones around his neck checks his mobile phone."

            },
            {
                heading: "Manage your money right from your phone",
                body: {
                    default: <>From money transfers<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> to setting limits and alerts,<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> the convenience of the Wells Fargo Mobile&reg; app makes handling multiple accounts easier.</>,
                    spending: <>From money transfers<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> to setting limits and alerts,<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> the convenience of the Wells Fargo Mobile&reg; app makes handling multiple accounts easier.</>,
                    insights: <>From money transfers<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> to setting limits and alerts,<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> the convenience of the Wells Fargo Mobile&reg; app makes handling multiple accounts easier.</>,
                    startsmart: <>From money transfers<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> to setting limits and alerts,<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> the convenience of the Wells Fargo Mobile&reg; app makes handling multiple accounts easier.</>,
                    savings: <>From money transfers<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> to setting limits and alerts,<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> the convenience of the Wells Fargo Mobile&reg; app makes handling multiple accounts easier.</>,
                    subscriptions: <>From money transfers<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> to setting limits and alerts,<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> the convenience of the Wells Fargo Mobile&reg; app makes handling multiple accounts easier.</>,
                    cardonoff: <>From money transfers<a id="body-sup-2" className={supStyles.bodySup} href="" aria-label="footnote 2"><sup>2</sup></a> to setting limits and alerts,<a id="body-sup-3" className={supStyles.bodySup} href="" aria-label="footnote 3"><sup>3</sup></a> the convenience of the Wells Fargo Mobile&reg; app makes handling multiple accounts easier.</>,
                },
                class: "bg2",
                alt: "A woman looks down at her mobile phone with its screen reflecting in her eyeglasses."

            },
            {
                heading: "Keep an eye on your spending",
                body: {
                    default: <>Track what you've spent by category, merchant, or month to month with Fargo&reg;<a id="body-sup-1" className={supStyles.bodySup} href="" aria-label="footnote 1"><sup>1</sup></a> in the Wells Fargo Mobile&reg; app.</>,
                    spending: <>Track what you've spent by category, merchant, or month to month with Fargo&reg;<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> in the Wells Fargo Mobile&reg; app.</>,
                    insights: <>Track what you've spent by category, merchant, or month to month with Fargo&reg;<a id="body-sup-3" className={supStyles.bodySup} href="" aria-label="footnote 3"><sup>3</sup></a> in the Wells Fargo Mobile&reg; app.</>,
                    startsmart: <>Track what you've spent by category, merchant, or month to month with Fargo&reg;<a id="body-sup-2" className={supStyles.bodySup} href="" aria-label="footnote 2"><sup>2</sup></a> in the Wells Fargo Mobile&reg; app.</>,
                    savings: <>Track what you've spent by category, merchant, or month to month with Fargo&reg;<a id="body-sup-3" className={supStyles.bodySup} href="" aria-label="footnote 3"><sup>3</sup></a> in the Wells Fargo Mobile&reg; app.</>,
                    subscriptions: <>Track what you've spent by category, merchant, or month to month with Fargo&reg;<a id="body-sup-1" className={supStyles.bodySup} href="" aria-label="footnote 1"><sup>1</sup></a> in the Wells Fargo Mobile&reg; app.</>,
                    cardonoff: <>Track what you've spent by category, merchant, or month to month with Fargo&reg;<a id="body-sup-1" className={supStyles.bodySup} href="" aria-label="footnote 1"><sup>1</sup></a> in the Wells Fargo Mobile&reg; app.</>,
                    
                },
                class: "bg1",
                alt: "A man smiles with confidence."

            },
            {
                heading: <>Get personalized account insights</>,
                body: {
                    default: 'View up to the moment info and insights, even get a little encouragement along the way in the Wells Fargo Mobile&reg; app.',
                    spending: 'View up to the moment info and insights, even get a little encouragement along the way in the Wells Fargo Mobile&reg; app.',
                    insights: 'View up to the moment info and insights, even get a little encouragement along the way in the Wells Fargo Mobile&reg; app.',
                    startsmart: 'View up to the moment info and insights, even get a little encouragement along the way in the Wells Fargo Mobile&reg; app.',
                    savings: 'View up to the moment info and insights, even get a little encouragement along the way in the Wells Fargo Mobile&reg; app.',
                    subscriptions: 'View up to the moment info and insights, even get a little encouragement along the way in the Wells Fargo Mobile&reg; app.',
                    cardonoff: 'View up to the moment info and insights, even get a little encouragement along the way in the Wells Fargo Mobile&reg; app.',
                },
                class: "bg3",
                alt: "A woman working out in a gym checks her mobile phone with a satisfied look."

            },
            {
                heading: <>Set goals and save for them</>,
                body: {
                    default: 'Setting goals and tracking savings is easier with the financial tools in the Wells Fargo Mobile&reg; app.', // Needed because has no HTML tags
                    spending: 'Setting goals and tracking savings is easier with the financial tools in the Wells Fargo Mobile&reg; app.', // Needed because has no HTML tags
                    insights: 'Setting goals and tracking savings is easier with the financial tools in the Wells Fargo Mobile&reg; app.', // Needed because has no HTML tags
                    startsmart: 'Setting goals and tracking savings is easier with the financial tools in the Wells Fargo Mobile&reg; app.', // Needed because has no HTML tags
                    savings: 'Setting goals and tracking savings is easier with the financial tools in the Wells Fargo Mobile&reg; app.', // Needed because has no HTML tags
                    subscriptions: 'Setting goals and tracking savings is easier with the financial tools in the Wells Fargo Mobile&reg; app.', // Needed because has no HTML tags
                    cardonoff: 'Setting goals and tracking savings is easier with the financial tools in the Wells Fargo Mobile&reg; app.', // Needed because has no HTML tags
                },
                class: "bg4",
                alt: "A hopeful man sits in his car smiling while holding his mobile phone."
            },
            {
                heading: <>Control your debit card when you want</>,
                body: {
                    default: 'Setting goals and tracking savings is easier with the financial tools in the Wells Fargo Mobile&reg; app.', // Needed because has no HTML tags
                    spending: 'Setting goals and tracking savings is easier with the financial tools in the Wells Fargo Mobile&reg; app.', // Needed because has no HTML tags
                    insights: 'Setting goals and tracking savings is easier with the financial tools in the Wells Fargo Mobile&reg; app.', // Needed because has no HTML tags
                    startsmart: 'Setting goals and tracking savings is easier with the financial tools in the Wells Fargo Mobile&reg; app.', // Needed because has no HTML tags
                    savings: 'Setting goals and tracking savings is easier with the financial tools in the Wells Fargo Mobile&reg; app.', // Needed because has no HTML tags
                    subscriptions: 'Setting goals and tracking savings is easier with the financial tools in the Wells Fargo Mobile&reg; app.', // Needed because has no HTML tags
                    cardonoff:  <>You can turn off your debit card and turn it back on again<a id="body-sup-1" className={supStyles.bodySup} href="" aria-label="footnote 1"><sup>1</sup></a> when you're ready in the Wells Fargo Mobile&reg; app.</>,
                },
                class: "bg5",
                alt: "A man checks his mobile phone with a self-assured look."
            },
            { // ?focus=cardonoff uses a mix of the tiles.  using a unique object for them
                heading: "Keep an eye on your spending",
                body: {
                    cardonoff: <>Track what you've spent by category, merchant, or month to month with Fargo&reg;<a id="body-sup-4" className={supStyles.bodySup} href="" aria-label="footnote 4"><sup>4</sup></a> in the Wells Fargo Mobile&reg; app.</>,
                },
                class: "bg3",
                alt: "A woman working out in a gym checks her mobile phone with a satisfied look."

            },
            {
                heading: <>Set up alerts and keep up with your account</>,
                body: {
                    default: <>Wells Fargo's fraud alerts help you protect your account, and you can also activate transaction alerts<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="footnote *"><sup>*</sup></a> to stay on top of your money.</>, 
                    spending: '', 
                    insights: '', 
                    startsmart: '', 
                    savings: '', 
                    subscriptions: '', 
                    cardonoff:  '',
                },
                class: "bg5",
                alt: "A man checks his mobile phone with a self-assured look."
            },
        ]
        : [
            {
                heading: <>Mantente al&nbsp;tanto&nbsp;de&nbsp;tus suscripciones</>,
                body: {
                    default: <>Con Fargo&reg;<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a>, tu asistente virtual en la app de Wells Fargo Mobile&reg; puedes ver fácilmente todas tus suscripciones.</>,
                    creditscore: <>Con Fargo&reg;<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a>, tu asistente virtual en la app de Wells Fargo Mobile&reg; puedes ver fácilmente todas tus suscripciones.</>,
                    savings: <>Con Fargo&reg;<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a>, tu asistente virtual en la app de Wells Fargo Mobile&reg; puedes ver fácilmente todas tus suscripciones.</>,
                    spending: <>Con Fargo&reg;<a id="body-sup-1" className={supStyles.bodySup} href="" aria-label="nota al pie 1"><sup>1</sup></a>, tu asistente virtual en la app de Wells Fargo Mobile&reg; puedes ver fácilmente todas tus suscripciones.</>,
                },
                class: "bg0",
                alt: "Un hombre con auriculares alrededor del cuello revisa su teléfono móvil."

            },
            {
                heading: "Maneja tu dinero desde tu teléfono",
                body: {
                    default: <>Desde transferencias de dinero<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a> hasta poder establecer límites y alertas<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a>, la comodidad de la app de Wells Fargo Mobile® hace que manejar varias cuentas sea más fácil.</>,
                    creditscore: <>Desde transferencias de dinero<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a> hasta poder establecer límites y alertas<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a>, la comodidad de la app de Wells Fargo Mobile® hace que manejar varias cuentas sea más fácil.</>,
                    savings: <>Desde transferencias de dinero<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a>  hasta poder establecer límites y alertas<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a>, la comodidad de la app de Wells Fargo Mobile® hace que manejar varias cuentas sea más fácil.</>,
                    spending: <>Desde transferencias de dinero<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a> hasta poder establecer límites y alertas<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a>, la comodidad de la app de Wells Fargo Mobile® hace que manejar varias cuentas sea más fácil.</>,
                },
                class: "bg2",
                alt: "Una mujer mira hacia abajo su teléfono móvil, con la pantalla reflejada en sus espejuelos."

            },
            {
                heading: "Controla tu tarjeta de débito en todo momento",
                body: {
                    default: <>Puedes desactivar tu tarjeta de débito, y volver a activarla<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a> cuando estés listo desde la app de Wells Fargo Mobile&reg;.</>,
                    creditscore: <>Puedes desactivar tu tarjeta de débito, y volver a activarla<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a> cuando estés listo desde la app de Wells Fargo Mobile&reg;.</>,
                    savings: <>Puedes desactivar tu tarjeta de débito, y volver a activarla<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a> cuando estés listo desde la app de Wells Fargo Mobile&reg;.</>,
                    spending: <>Puedes desactivar tu tarjeta de débito, y volver a activarla<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a> cuando estés listo desde la app de Wells Fargo Mobile&reg;.</>,
                },
                class: "bg1",
                alt: "Un hombre sonríe con confianza."
            },
            {
                heading: <span>Establece alertas para estar al tanto de tu cuenta</span>,
                body: {
                    default: "Las alertas de fraude de Wells Fargo te ayudan a proteger tu cuenta, y además puedes activar alertas de transacciones para mantenerte al tanto de tu dinero.",
                    creditscore: "Las alertas de fraude de Wells Fargo te ayudan a proteger tu cuenta, y además puedes activar alertas de transacciones para mantenerte al tanto de tu dinero.",
                    savings: "Las alertas de fraude de Wells Fargo te ayudan a proteger tu cuenta, y además puedes activar alertas de transacciones para mantenerte al tanto de tu dinero.",
                    spending: "Las alertas de fraude de Wells Fargo te ayudan a proteger tu cuenta, y además puedes activar alertas de transacciones para mantenerte al tanto de tu dinero."
                },


                class: "bg3",
                alt: "Un hombre revisa su teléfono móvil con una expresión segura de sí mismo."

            },
            {
                heading: <>Monitorea tus ahorros fácilmente</>,
                body: {
                    default: "Con la app de Wells Fargo Mobile®, puedes establecer metas de ahorro, y monitorear tu progreso.",
                    creditscore: "Con la app de Wells Fargo Mobile®, puedes establecer metas de ahorro, y monitorear tu progreso.",
                    savings: "Con la app de Wells Fargo Mobile®, puedes establecer metas de ahorro, y monitorear tu progreso.",
                    spending: "Con la app de Wells Fargo Mobile®, puedes establecer metas de ahorro, y monitorear tu progreso.",
                },
                class: "bg4",
                alt: "Una mujer usa su teléfono móvil con una sonrisa esperanzadora."
            },
            { // CSBB-146 - new tile created
                heading: <>Mantente al tanto de tus gastos</>,
                body: {
                    default: <>Monitorea lo que gastas por categoría, por comerciante o mes a mes con Fargo®<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a> en la app de Wells Fargo Mobile.</>,
                    creditscore: <>Monitorea lo que gastas por categoría, por comerciante o mes a mes con Fargo®<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a> en la app de Wells Fargo Mobile®.</>,
                    savings: <>Monitorea lo que gastas por categoría, por comerciante o mes a mes con Fargo®<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a> en la app de Wells Fargo Mobile®.</>,
                    spending: <>Monitorea lo que gastas por categoría, por comerciante o mes a mes con Fargo®<a id="body-sup-*" className={supStyles.bodySup} href="" aria-label="nota al pie *"><sup>*</sup></a> en la app de Wells Fargo Mobile®.</>,

                },
                class: "bg5",
                alt: "Una mujer haciendo ejercicio en un gimnasio revisa su teléfono móvil con una mirada de satisfacción."
            }
        ];

    const orderedCopy = contentOrder.map((copyIndex: number) => tabCopy[copyIndex]) 

    let supTracker = isStartSmart ? 1 : 0;
    useEffect(() => {
        if (!loaded) {
            setLoaded(true);
        }
        supTracker = 0
    }, [loaded]);

    useEffect(() => {

        if (tileRefs.length === 5 && contentRefs.length === 5) {

            // if (window.innerWidth < 1080) {
            //     setTileHeightOpen(dataLang === 'es' ? 320 : 280);
            //     return;
            // }


            const getLargest = () => {

                tileRefs.forEach((tileRef, index) => {
                    const contentRef = contentRefs[index]
                    console.log('getLargest')
                    // save largest
                    if (tileRef.current && contentRef.current) {

                        const tileContentHeight = () => contentRef.current!.offsetHeight
                        const tileContentTop = () => parseInt(window.getComputedStyle(contentRef.current!.parentElement!).top.replace("px", ""), 10);

                        const currentTitleHeight = contentRef.current.querySelector('h2');
                        // console.log('h2 ', currentTitleHeight.offsetHeight )
                        const tileHeight = tileContentTop() + tileContentHeight() + 7;

                        if (currentTitleHeight.offsetHeight > titleHeight) {
                            // console.log('here')
                            // Take the tallest h2 and get that contentRef's height
                            setTitleHeight(tileContentHeight)
                        }
                        
                        // if (tileHeight > tileHeightOpen) {
                        //     setTileHeightOpen(tileHeight)
                        // }

                    }

                })

            }


            getLargest();


            tileRefs.forEach((tileRef, index) => {

                tileRef.current.addEventListener('click', getLargest())
                window.addEventListener('resize', getLargest );
            })

        }

    }, [contentRefs, tileRefs])

    return (<div id="tile-container" className={classNames([styles.parentContainer, 'fullscreen'])} data-tracking="section-cards">
            <div id="vertical-tile-container" className={styles.verticalTileContainer}>
                <div className={styles.content}>
                    <h2 className={classNames([isStartSmart && styles.startsmart])} data-lang={dataLang}>

                        {process.env.REACT_APP_LANG === 'spanish' ? JSONContent.headline.spanish.default : JSONContent.headline.english[isStartSmart ? 'startsmart' : 'default']}

                    </h2>
                    <div className={styles.tileContainer}>
                        <div
                            role="region"
                            className={classNames([styles.tablist, 'side-by-side'])}>

                            {
                                orderedCopy.map((x: any, i: number) => {
                                        const regex = /(<a.*?<\/a>)/
                                        const newStr = renderToString(x.body[focus]).split(regex);
                                        // const newStr = renderToString(x.body).split(regex);

                                        if (newStr.length > 1) {
                                            x.body[focus] = newStr.map((y, i) => {
                                            // x.body = newStr.map((y, i) => {
                                                if (y.includes('*')) {
                                                    supTracker++;
                                                }
                                                return y.replaceAll('*', supTracker.toString() + '')
                                            }).join('');
                                        }
                                        // console.log(x.body[focus]);
                                        // console.log(x.body);

                                        return <Tile copy={x} key={`tab-${i}`} index={i}
                                            isSelected={i === selected}
                                            userStylesApplied={userStylesApplied}
                                            handleClick={() => {
                                                setSelected(i === selected ? -1 : i)
                                            }}
                                            titleHeight={titleHeight}
                                            tileHeightOpen={tileHeightOpen}
                                            setTileHeightOpen={setTileHeightOpen}
                                            tileHeightClosed={tileHeightClosed}
                                            setTileHeightClosed={setTileHeightClosed}

                                            tileRef={tileRefs[i]}
                                            contentRef={contentRefs[i]}



                                            focus={focus}

                                        />
                                    }
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default TileContainer;
